export default __webpack_public_path__ + "static/media/7_Kletterpartie_.741813b0.png";